import React from 'react';
import { MOCK_INVOICES } from '../../mock';
import Badge from '../../components/common/Badge';
import { Download, CreditCard } from 'lucide-react';

const statusVariant: Record<string, any> = {
  draft: 'default', sent: 'info', paid: 'success', overdue: 'danger', cancelled: 'danger',
};

const CustomerInvoices: React.FC = () => (
  <div>
    <h2 style={{ fontWeight: 800, fontSize: '1.5rem', marginBottom: '1.5rem', color: 'var(--text-primary)' }}>Invoices & Payments</h2>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      {MOCK_INVOICES.map(inv => (
        <div key={inv.id} className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                <h3 style={{ fontWeight: 700, color: 'var(--text-primary)', margin: 0 }}>{inv.invoiceNumber}</h3>
                <Badge label={inv.status} variant={statusVariant[inv.status]} />
              </div>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>
                {inv.items[0]?.description}
              </p>
              <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', margin: 0 }}>
                Due: {inv.dueDate}{inv.paidDate ? ` · Paid: ${inv.paidDate}` : ''}
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '1.5rem', fontWeight: 800, color: inv.status === 'paid' ? '#10b981' : inv.status === 'overdue' ? '#ef4444' : 'var(--text-primary)', marginBottom: '0.5rem' }}>
                ${inv.total.toLocaleString()}
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                <button className="btn-ghost" style={{ fontSize: '0.8rem', padding: '0.375rem 0.75rem' }}>
                  <Download size={14} /> PDF
                </button>
                {inv.status !== 'paid' && (
                  <button className="btn-primary" style={{ fontSize: '0.8rem', padding: '0.375rem 0.875rem' }}>
                    <CreditCard size={14} /> Pay Now
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Line Items */}
          <div style={{ marginTop: '1rem', borderTop: '1px solid var(--border-color)', paddingTop: '1rem' }}>
            {inv.items.map(item => (
              <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', padding: '0.375rem 0', color: 'var(--text-secondary)' }}>
                <span>{item.description}</span>
                <span style={{ fontWeight: 600, color: 'var(--text-primary)' }}>${item.total.toLocaleString()}</span>
              </div>
            ))}
            <div style={{ borderTop: '1px solid var(--border-color)', marginTop: '0.5rem', paddingTop: '0.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '0.2rem' }}>
                <span>Subtotal</span><span>${inv.subtotal.toLocaleString()}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '0.2rem' }}>
                <span>Tax</span><span>${inv.tax.toLocaleString()}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, color: 'var(--text-primary)' }}>
                <span>Total</span><span>${inv.total.toLocaleString()}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default CustomerInvoices;
